import { Flex, FlexProps, Text, Icon, IconProps } from "@chakra-ui/react";
import EtherAmount from "components/EtherAmount";
import HoneyIcon from "components/HoneyIcon";
import { BigNumber } from "ethers";
import useTranslate from "hooks/useTranslate";

type HoneyAmountProps = FlexProps & {
  amount: BigNumber;
  iconColor?: IconProps["color"];
  iconSize?: IconProps["w"];
  asPrice?: boolean;
};

const HoneyAmount = ({
  amount,
  iconColor,
  iconSize,
  asPrice,
  ...rest
}: HoneyAmountProps) => {
  const translate = useTranslate();

  return (
    <Flex align="center" gap="1" flex="none" {...rest}>
      <Icon as={HoneyIcon} color={iconColor} w={iconSize} h={iconSize} />

      <Text>
        {asPrice ? (
          amount.gt("0") ? (
            <EtherAmount amount={amount} />
          ) : (
            translate("common:free")
          )
        ) : (
          <EtherAmount amount={amount} />
        )}
      </Text>
    </Flex>
  );
};

export default HoneyAmount;
